(async () => {
  const shareButtons = Array.from(document.querySelectorAll('.js-share-button'));
  for (const shareButton of shareButtons) {
    shareButton.addEventListener('click', () => {
      const content = shareButton.parentElement.querySelector('.js-share-content');
      if (content.style.display === 'flex') {
        content.style.display = '';
      } else {
        content.style.display = 'flex';
      }
    });
    const closeButton = shareButton.parentElement.querySelector('.js-share-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        const content = shareButton.parentElement.querySelector('.js-share-content');
        content.style.display = '';
      });
    }
    document.addEventListener('click', (event) => {
      const content = shareButton.parentElement.querySelector('.js-share-content');
      if (content.style.display === 'flex' && !shareButton.contains(event.target) && !content.contains(event.target)) {
        content.style.display = '';
      }
    });
  }
  const shareOptions = Array.from(document.querySelectorAll('.js-share-option'));
  for (const shareOption of shareOptions) {
    shareOption.addEventListener('click', () => {
      const platform = shareOption.dataset.platform;
      const url = shareOption.dataset.url;
      const page_handle = shareOption.dataset.pageHandle;
      const product_id = shareOption.dataset.productId;
      trackAnalytics({ platform, url, product_id, page_handle });
    });
  }

  const emailButtons = Array.from(document.querySelectorAll('.js-share-option[data-platform="email"]'));

  emailButtons.forEach((emailButton) => {
    emailButton.addEventListener('click', () => {
      buildEmailModal();
    });
  });

  function trackAnalytics({ platform, url, product_id, page_handle }) {
    return fetch('https://www.fpapplications.com/shareButton', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-store-id': 1,
      },
      body: JSON.stringify({
        platform,
        url,
        product_id,
        page_handle,
        customer_id: window.CUSTOMER_ID || null,
        session_id: window.SESSION_ID || null,
      }),
    });
  }

  function buildEmailModal() {
    const modal = document.createElement('div');
    modal.classList.add('fp-share__email-modal');
    modal.innerHTML = `
      <div class="fp-share__email-modal__content">
        <span class="fp-share__email-modal__close-button js-share-close">&times;</span>
        <h2 class="fp-share__title">Share via Email</h2>
        <form class="fp-share__email-form js-share-email-form">
          <label for="email-name">Your Name:</label>
          <input type="text" id="name" name="name" required />
          <label for="email">Recipient Email:</label>
          <input type="email" id="email" name="email" required />
          <label for="message">Body:</label>
          <textarea id="message" name="body" placeholder="Enter your message here (optional)"></textarea>
          <button type="submit">Send Email</button>
        </form>
      </div>
    `;
    document.body.appendChild(modal);
    document.querySelector('html').classList.add('overflow-hidden');
    const observer = new MutationObserver(() => {
      if (!document.body.contains(modal)) {
        document.querySelector('html').classList.remove('overflow-hidden');
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true });

    const closeButton = modal.querySelector('.js-share-close');
    closeButton.addEventListener('click', () => {
      modal.remove();
    });

    const form = modal.querySelector('.js-share-email-form');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const name = form.querySelector('#name').value;
      const body = form.querySelector('#message').value;
      const email = form.querySelector('#email').value;
      const subject = `${name} thinks you may be interested in this`;
      const image = emailButtons[0].dataset.image || '';
      const url = window.location.href;
      sendEmail({ subject, body, email, image, url })
        .then((res) => {
          if (!res.ok) {
            window.toast.error('Error sending email, please try again later!');
          } else {
            window.toast.success('Email sent successfully');
            modal.remove();
          }
        })
        .catch((err) => {
          console.error(err);
          window.toast.error('Error sending email, please try again later!');
        });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.remove();
      }
    });

    return modal;
  }

  function sendEmail({ subject, body, email, image, url }) {
    return fetch('http://www.fpapplications.com/shareButton/email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-store-id': 1,
      },
      body: JSON.stringify({
        subject,
        page_title: document.title,
        body,
        email,
        image,
        url,
      }),
    });
  }
})();
